module.exports = __webpack_public_path__ + "img/home-banner-3-discount-en.2d54e9ce.png";